/**
 * Extracts a 32-character hex token from a scanned QR string.
 *
 * Accepts URL forms (server endpoints, see EmployeeQrCodeService::getProfileUrl
 * and *QrCodeService::getProfileUrl for each entity):
 *   - …/asset/TOKEN     — Tool entity (SRD devices, generated by EmployeeQrCodeService)
 *   - …/tool/TOKEN      — ToolInventoryItem (legacy VB6-synced inventory)
 *   - …/srd-tool/TOKEN  — ExternalToolQr — SRD devices from external ToolInventory
 *   - …/ext-tool/TOKEN  — legacy alias for /srd-tool/ (older printed stickers)
 *   - …/eq/TOKEN        — internal Equipment
 *   - …/ext/TOKEN       — external Equipment tag
 *   - …/t/TOKEN         — Employee / Temp profile
 *
 * Also accepts a raw 32-hex token (manual entry).
 *
 * Returns the lowercase token, or null if the input doesn't match.
 *
 * IMPORTANT: when adding a new QR-owning entity, add its URL prefix here
 * AND register the matching prefix in EmployeeQrCodeService::getProfileUrl.
 */
export function extractQrToken(text) {
    if (!text) return null;
    const urlMatch = text.match(/\/(?:asset|tool|srd-tool|ext-tool|eq|ext|t)\/([a-f0-9]{32})/i);
    if (urlMatch) return urlMatch[1].toLowerCase();
    const trimmed = text.trim();
    if (/^[a-f0-9]{32}$/i.test(trimmed)) return trimmed.toLowerCase();
    return null;
}
